var version = require("./version")

module.exports = isVirtualNode

function isVirtualNode(x) {
    return x && x.type === "VirtualNode" && x.version === version
}



//////////////////
// WEBPACK FOOTER
// C:/Users/tomas/OneDrive/Tomas/Materials/Talks/2018/live-compilers/code/completed/node_modules/virtual-dom/vnode/is-vnode.js
// module id = 12
// module chunks = 0